import axios from "axios";
import { ToastDanger } from "utils/toast/Toast";

export const axiosInterceptors = axios.create();

axiosInterceptors.interceptors.request.use(
  (req: any) => {
    req.headers["Authorization"] = localStorage.getItem("token")
      ? `${localStorage.getItem("token")}`
      : "";
    req.headers["Content-Type"] = "application/json";
    req.headers["Accept"] = "application/json";
    req.headers["X-App-Version"] =
      process.env.REACT_APP_VERSION || "v0.0.0-vnotfound";

    return req;
  },
  (err) => {
    return Promise.reject(err);
  },
);
axiosInterceptors.interceptors.response.use(
  (res: any) => {
    return res;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.message === "Network Error") {
      ToastDanger("لطفا اینترنت خود را متصل کنید");
    } else if (error.response.status === 401) {
      ToastDanger("لطفا مجددا وارد شوید");
      localStorage.removeItem("token");
      window.location.reload();
    } else if (error.response.status === 500) {
      if (originalRequest._retry) {
        ToastDanger("خطا در انجام عملیات");
      } else {
        originalRequest._retry = true;
        return axiosInterceptors(originalRequest);
      }
    } else if (error.response.status >= 501 && error.response.status <= 599) {
      if (originalRequest._retry) {
        ToastDanger("خطا در ارتباط با سرور لطفا مجددا تلاش کنید");
      } else {
        originalRequest._retry = true;
        return axiosInterceptors(originalRequest);
      }
    } else if (error.response.status === 404) {
      ToastDanger("یافت نشد");
    } else if (error.response.status === 400) {
      ToastDanger(`${error.response.data.message}`);
    } else if (error.response.status === 408) {
    } else if (error.response.status === 424) {
    } else {
      ToastDanger("خطای نامشخص");
    }
    return Promise.reject(error);
  },
);
